import { request_data, } from "../utils/request";

/**
 * 登陆
 */
//主题相关数据
export const env_data = () => {
    return request_data.get('/env_data');
}
//welcome页面头部标签数据
export const welcome_title_data = () => {
    return request_data.get('/title_data');
}
//事件表格折线图数据
export const events_report_data = () => {
    return request_data.get('/events_by_severity');
}
//事件表格数据
export const events_tableData = () => {
    return request_data.get('/last_30d_events');
}
//  * 获取用户信息
//  */
//  zabbix_dashboard_1
export const getAdminInfo = () => {
    return request_data.get('/admin_info');
}//  */

export const host_bygroups = () => {
    return request_data.get('/host_bygroups');
}
// /**
//  */

export const problem_top10 = () => {
    return request_data.get('/problem_top10');
}
// /**
//  */

export const host_status = () => {
    return request_data.get('/host_status');
}
// /**
//  */

export const problems_info = () => {
    return request_data.get('/problems_info');
}
// /**
//  */

export const server_status = () => {
    return request_data.get('/server_status');
}
// /**
//  */

export const network_traffic_top10 = () => {
    return request_data.get('/network_traffic_top10');
}
// /**
//  */

export const CPU_utilization_top10 = () => {
    return request_data.get('/CPU_utilization_top10');
}
// /**
//  */

export const MEM_utilization_top10 = () => {
    return request_data.get('/MEM_utilization_top10');
}
// /**
//  */

export const space_utilization_top10 = () => {
    return request_data.get('/Space_utilization_top10');
}
// /**

